<div class="tests-container">
  <div *ngIf="availableTests.screeningTests.length != 0" class="screening-container">
    <h4 class="tests-tittle">Screening Tests</h4>
    <div *ngFor="let test of screeningFormArray().controls">
      <span class="test-label">{{ test.get('label').value }}</span>
      <input type="checkbox"
             [formControl]="test.get('selected')"
             [attr.disabled]="disableScreeningSelection(test)"
             class="test-checkbox">
    </div>
  </div>

  <div *ngIf="availableTests.labAndImagingTests.length != 0">
    <h4 class="tests-tittle">Lab and Image Tests</h4>
    <div *ngFor="let test of labAndImageFormArray().controls">
      <span class="test-label">{{ test.get('label').value }}</span>
      <input type="checkbox"
             [formControl]="test.get('selected')"
             [attr.disabled]="disableLabAndImageSelection(test)"
             class="test-checkbox">
    </div>
  </div>
</div>
